import { MonitoringTimeHistoryPeriod } from '@neptune/pricing-commons-domain';

export function trimPeriodsToDate(
  periods: MonitoringTimeHistoryPeriod[],
  date: Date,
): MonitoringTimeHistoryPeriod[] {
  return periods.filter((period) => period.periodStart.getTime() <= date.getTime());
}
